import { useQuery, UseQueryOptions } from 'react-query';

import { TimeOffType } from 'api';
import { useFetchErp } from 'hooks';

function useTimeOffTypesQuery(options?: UseQueryOptions<TimeOffType[], Error>) {
  const authorisedFetch = useFetchErp();

  return useQuery<TimeOffType[], Error>(
    ['time-off-types'],
    async () => {
      const response = await authorisedFetch('/time_off/types', {
        method: 'GET',
      });

      return await response.json();
    },
    options,
  );
}

export default useTimeOffTypesQuery;
